$(function(){
    let control = false;
    const featuredCaseStudySettings = {
        classes: {
            clickableLinkDotClass: 'featured-case-study__clickable-link-dot'
        },
        selectors: {
            clickableLinkDotSelector: '.featured-case-study__clickable-link-dot',
            clickableLinksContainerSelector: ".featured-case-study__clickable-links-container",
            featuredCaseStudySelector: ".featured-case-study"
        },
        specs: {
            dotTextDescription: 'bold 10px Quicksand, sans-serif'
        }
    }


    const calcTextWidth = function(text, font) {
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
      }

    const insertText = function(dot){
        let text = `Featured: <a href="${dot.getAttribute('data-product-url')}" target="_blank">${dot.getAttribute('data-product-title')}</a>`;
        dot.innerHTML = text;
    }

    const modifyDotDimensions = function(dot, dots, status){
        dots.forEach((singleDot) => {
            singleDot.setAttribute('style', '');
            singleDot.innerHTML = '';
        });
        if(dot){
            let textWidth = 1.13 * (calcTextWidth(`Featured: ${dot.getAttribute('data-product-title')}`, featuredCaseStudySettings.specs.dotTextDescription));
            let percentageAcross = parseInt(dot.getAttribute('data-position-percentage-across'));
            if(status){
                let newStyling = percentageAcross > 50 ? `right: calc(${100 - percentageAcross}% - 28px); left: calc(${percentageAcross}% - ${textWidth + 16}px + 28px); width: ${textWidth + 16}px` : `width: ${textWidth + 16}px`;
                dot.setAttribute('style', newStyling);
                insertText(dot);
            
            } else {
                dot.style.width = '28px'
            }
        }
    }

    const handleDotEvent = function(event, dot, dots){
        let status;
        if(event !== "click outside"){
            status = !(dot.getAttribute('data-showing') === "true");
        }
      
        dots.forEach((singleDot) => {
            (singleDot.setAttribute('data-showing', false));
            (singleDot.setAttribute('data-transitioning', true));
            setTimeout(() => {
                (singleDot.setAttribute('data-transitioning', false));
              }, 200);
              
        });
        if(event !== "click outside"){
            dot.setAttribute('data-showing', status);
            modifyDotDimensions(dot, dots, status);
        } else {
            modifyDotDimensions(null, dots, null);
        }
    }

    const onClickOutside = function(e, dots) {
        if (!e.target.className.includes(featuredCaseStudySettings.classes.clickableLinkDotClass)) {
            handleDotEvent('click outside', null, dots)
        }
      };

    const initDotHoverFocusEvent = function(){
        let dots = document.querySelectorAll(`${featuredCaseStudySettings.selectors.clickableLinkDotSelector}`);
        if(dots.length > 0){
            dots.forEach((dot) => {
                if(window.Branch.functions.isTouchDevice()) {
                    dot.addEventListener('click', (e) => {
                        handleDotEvent('click', dot, dots)
                    });
                    let imageInnerContainer = document.querySelector(`${featuredCaseStudySettings.selectors.clickableLinksContainerSelector}`)
                    imageInnerContainer.addEventListener("click", function(e){
                        onClickOutside(e, dots)
                    });
                } else {
                    dot.addEventListener('mouseenter', (e) => {
                            handleDotEvent('mouseover', dot, dots);
                        
                    }, false);
                    dot.addEventListener('mouseleave', (e) => {
                            handleDotEvent('mouseleave', dot, dots);
                    }, false)
                }
            })
        }
    }

    const handleControlVariant = function(){
        const featuredCaseStudy = document.querySelector(`${featuredCaseStudySettings.selectors.featuredCaseStudySelector}`);
        const featuredCaseStudyStyle = featuredCaseStudy ? featuredCaseStudy.previousElementSibling : null;
        const featuredCaseStudyScript = featuredCaseStudy ? featuredCaseStudy.nextElementSibling : null;

        if(featuredCaseStudy){featuredCaseStudy.remove()};
        if(featuredCaseStudyStyle){featuredCaseStudyStyle.remove()};
        if(featuredCaseStudyScript){featuredCaseStudyScript.remove()};
    }

    const initFeaturedCaseStudy = function(){
        if(!control){
            initDotHoverFocusEvent();
            let shogunElement = document.querySelector('#s-9590efca-b1d6-45bd-84d4-935e228e1d77');
            if(shogunElement){
                shogunElement.remove();
            }
        }
    }

    window.addEventListener('load', function(){
        initFeaturedCaseStudy();
      });
});
